require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./wir-feiern-richtfest.json") })
        }
      }, "path---wir-feiern-richtfest");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---wir-feiern-richtfest!./.cache/json/wir-feiern-richtfest.json
// module id = 436
// module chunks = 231608221292675